const videoList = [
    {
        "id":  "expozoare",
        "name":  "Expozoare",
        "codVideo":  "exp",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "expozoare--general--1",
                                                "titlu":  "Prezentare expozor",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195289178",
                                                "thumbnail":  "",
                                                "produs":  "Expozoare",
                                                "codVideo":  "exp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "expozoare--general--2",
                                                "titlu":  "Banner",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206425920",
                                                "thumbnail":  "",
                                                "produs":  "Expozoare",
                                                "codVideo":  "exp",
                                                "folder":  "General"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "jaluzele-verticale",
        "name":  "Jaluzele verticale",
        "codVideo":  "jvv",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "jaluzele-verticale--general--1",
                                                "titlu":  "Măsurătoare Jaluzele verticale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195868056",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele verticale",
                                                "codVideo":  "jvv",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-verticale--general--2",
                                                "titlu":  "Montaj jaluzele verticale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195869286",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele verticale",
                                                "codVideo":  "jvv",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-verticale--general--3",
                                                "titlu":  "Tipurile de acționări pt Jaluzele verticale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195870274",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele verticale",
                                                "codVideo":  "jvv",
                                                "folder":  "General"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "jaluzele-tip-perdea",
        "name":  "Jaluzele tip perdea",
        "codVideo":  "jvp",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "jaluzele-tip-perdea--general--1",
                                                "titlu":  "Măsurătoare Jaluzele tip perdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195871298",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-perdea--general--2",
                                                "titlu":  "Prezentare jaluzele tip perdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195872451",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-perdea--general--3",
                                                "titlu":  "Tipurile de acționări pt Jaluzele tip Perdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195877107",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-perdea--general--4",
                                                "titlu":  "ClipsareDeclipsareLameleJaluzeleTipPerdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1196320391",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-perdea--general--5",
                                                "titlu":  "ModalitateImbinareLameleTipPerdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1196321105",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-perdea--general--6",
                                                "titlu":  "PrezentareAmbalareJaluzeaTipPerdea",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1196322138",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip perdea",
                                                "codVideo":  "jvp",
                                                "folder":  "General"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "jaluzele-tip-idilia",
        "name":  "Jaluzele tip Idilia",
        "codVideo":  "jvi",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "jaluzele-tip-idilia--general--1",
                                                "titlu":  "Măsurătoare Jaluzele Idilia",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195878206",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip Idilia",
                                                "codVideo":  "jvi",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-idilia--general--2",
                                                "titlu":  "Montaj jaluzele Idilia",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195879231",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip Idilia",
                                                "codVideo":  "jvi",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "jaluzele-tip-idilia--general--3",
                                                "titlu":  "Tipurile de acționări pt Jaluzele Idilia",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195880028",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele tip Idilia",
                                                "codVideo":  "jvi",
                                                "folder":  "General"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "jaluzele-plisate",
        "name":  "Jaluzele Plisate",
        "codVideo":  "roj",
        "sections":  [
                         {
                             "id":  "jaluzea-plisata-aplicata",
                             "name":  "Jaluzea plisata aplicata",
                             "videos":  [
                                            {
                                                "id":  "jaluzele-plisate--jaluzea-plisata-aplicata--1",
                                                "titlu":  "Măsurătoare jaluzele plisate aplicate",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195880549",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele Plisate",
                                                "codVideo":  "roj",
                                                "folder":  "Jaluzea plisata aplicata"
                                            },
                                            {
                                                "id":  "jaluzele-plisate--jaluzea-plisata-aplicata--2",
                                                "titlu":  "Montaj jaluzea plisata aplicata.mov",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195880836",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele Plisate",
                                                "codVideo":  "roj",
                                                "folder":  "Jaluzea plisata aplicata"
                                            }
                                        ]
                         },
                         {
                             "id":  "jaluzea-plisata-incadrata",
                             "name":  "Jaluzea plisata incadrata",
                             "videos":  [
                                            {
                                                "id":  "jaluzele-plisate--jaluzea-plisata-incadrata--1",
                                                "titlu":  "Măsurătoare jaluzele plisate incadrate",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195883275",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele Plisate",
                                                "codVideo":  "roj",
                                                "folder":  "Jaluzea plisata incadrata"
                                            },
                                            {
                                                "id":  "jaluzele-plisate--jaluzea-plisata-incadrata--2",
                                                "titlu":  "Montaj jaluzea plisata încadrată",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195883962",
                                                "thumbnail":  "",
                                                "produs":  "Jaluzele Plisate",
                                                "codVideo":  "roj",
                                                "folder":  "Jaluzea plisata incadrata"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "rolete-textile",
        "name":  "Rolete textile",
        "codVideo":  "ro",
        "sections":  [
                         {
                             "id":  "roleta-simpla",
                             "name":  "ROLETA SIMPLA",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--roleta-simpla--1",
                                                "titlu":  "Montaj roletă simplă",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195884788",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "ROLETA SIMPLA"
                                            },
                                            {
                                                "id":  "rolete-textile--roleta-simpla--2",
                                                "titlu":  "MASURATOARE ROLETA SIMPLA",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195886765",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "ROLETA SIMPLA"
                                            },
                                            {
                                                "id":  "rolete-textile--roleta-simpla--3",
                                                "titlu":  "Prezentare roleta simpla",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215170859",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "ROLETA SIMPLA"
                                            }
                                        ]
                         },
                         {
                             "id":  "day-night-simplu",
                             "name":  "DAY\u0026NIGHT SIMPLU",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--day-night-simplu--1",
                                                "titlu":  "Prezentare roleta simpla DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215171447",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT SIMPLU"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-simplu--2",
                                                "titlu":  "Masuratoare roleta simpla DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206435582",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT SIMPLU"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-simplu--3",
                                                "titlu":  "Montaj_actionare roleta simpla DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206434325",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT SIMPLU"
                                            }
                                        ]
                         },
                         {
                             "id":  "caseta-standard",
                             "name":  "CASETA STANDARD",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--caseta-standard--1",
                                                "titlu":  "Montaj roleta cu caseta standard material semiopac sau opac (2)",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195887742",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA STANDARD"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-standard--2",
                                                "titlu":  "Prezentare caseta standard",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206433057",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA STANDARD"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-standard--3",
                                                "titlu":  "Masuratoare caseta standard",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215169026",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA STANDARD"
                                            }
                                        ]
                         },
                         {
                             "id":  "caseta-avangard",
                             "name":  "CASETA AVANGARD",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--caseta-avangard--1",
                                                "titlu":  "Montaj roleta cu caseta standard si avangard material semiopac sau opac (2)",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195891405",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA AVANGARD"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-avangard--2",
                                                "titlu":  "Prezentare caseta avangard",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206430534",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA AVANGARD"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-avangard--3",
                                                "titlu":  "Masuratare caseta avangard",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215169631",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA AVANGARD"
                                            }
                                        ]
                         },
                         {
                             "id":  "day-night-cas-standard",
                             "name":  "DAY\u0026NIGHT CAS. STANDARD",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--day-night-cas-standard--1",
                                                "titlu":  "Montajul roletei cu caseta standard material day-night",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195892141",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. STANDARD"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-cas-standard--2",
                                                "titlu":  "Prezentare caseta standard DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206433112",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. STANDARD"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-cas-standard--3",
                                                "titlu":  "Masuratoare caseta standard DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215169026",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. STANDARD"
                                            }
                                        ]
                         },
                         {
                             "id":  "day-night-cas-avangard",
                             "name":  "DAY\u0026NIGHT CAS. AVANGARD",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--day-night-cas-avangard--1",
                                                "titlu":  "Montajul roletei cu caseta standard si avangard material day-night",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195892509",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. AVANGARD"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-cas-avangard--2",
                                                "titlu":  "Prezentare caseta avangard DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206430582",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. AVANGARD"
                                            },
                                            {
                                                "id":  "rolete-textile--day-night-cas-avangard--3",
                                                "titlu":  "Masuratoare caseta avangard DN",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215169631",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "DAY\u0026NIGHT CAS. AVANGARD"
                                            }
                                        ]
                         },
                         {
                             "id":  "caseta-premium-cu-lant",
                             "name":  "CASETA PREMIUM CU LANT",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-lant--1",
                                                "titlu":  "Măsurătoare roleta cu caseta premium cu lant si cu arc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195893077",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU LANT"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-lant--2",
                                                "titlu":  "Montaj roleta cu caseta premium cu lanț",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195894229",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU LANT"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-lant--3",
                                                "titlu":  "Prezentare caseta premium cu lant avangard",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215175152",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU LANT"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-lant--4",
                                                "titlu":  "Montaj roletă cu casetă premium cu arc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195893122",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU LANT"
                                            }
                                        ]
                         },
                         {
                             "id":  "caseta-premium-cu-arc",
                             "name":  "CASETA PREMIUM CU ARC",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-arc--1",
                                                "titlu":  "Măsurătoare roleta cu caseta premium cu lant si cu arc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195893077",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU ARC"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-arc--2",
                                                "titlu":  "Montaj roletă cu casetă premium cu arc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195893122",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU ARC"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-premium-cu-arc--3",
                                                "titlu":  "Prezentare caseta premium cu arc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206431557",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA PREMIUM CU ARC"
                                            }
                                        ]
                         },
                         {
                             "id":  "caseta-velux",
                             "name":  "CASETA VELUX",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--caseta-velux--1",
                                                "titlu":  "Prezentarea casetei Velux",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195895024",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA VELUX"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-velux--2",
                                                "titlu":  "Masuratoare pentru Velux",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195893983",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA VELUX"
                                            },
                                            {
                                                "id":  "rolete-textile--caseta-velux--3",
                                                "titlu":  "Montarea casetei Velux",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195894764",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CASETA VELUX"
                                            }
                                        ]
                         },
                         {
                             "id":  "carnival",
                             "name":  "CARNIVAL",
                             "videos":  [
                                            {
                                                "id":  "rolete-textile--carnival--1",
                                                "titlu":  "Măsurătoare roleta carnival",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1206430058",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CARNIVAL"
                                            },
                                            {
                                                "id":  "rolete-textile--carnival--2",
                                                "titlu":  "Montaj roleta carnival",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215173188",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CARNIVAL"
                                            },
                                            {
                                                "id":  "rolete-textile--carnival--3",
                                                "titlu":  "Prezentare roleta carnival",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1215172317",
                                                "thumbnail":  "",
                                                "produs":  "Rolete textile",
                                                "codVideo":  "ro",
                                                "folder":  "CARNIVAL"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "rulouri-aplicate",
        "name":  "Rulouri aplicate",
        "codVideo":  "rea",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "rulouri-aplicate--general--1",
                                                "titlu":  "Montaj tabachera șnur_panglica",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195896863",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--2",
                                                "titlu":  "Reglaj capăt cursa covorul sus și jos",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195898298",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--3",
                                                "titlu":  "Capăt de cursa a covorului jos",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195898964",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--4",
                                                "titlu":  "Capăt de cursa a covorului sus",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195899019",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--5",
                                                "titlu":  "Cum se scrie în aplicație un rulou casetă comuna",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195899618",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--6",
                                                "titlu":  "Măsurătoare rulou aplicat cu plasa",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195899685",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--7",
                                                "titlu":  "Măsurători rulouri în casetă comuna",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195900640",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--8",
                                                "titlu":  "Privire_rulou_pentru_producție",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195900746",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--general--9",
                                                "titlu":  "Tipuri de acționare -scoaterea șnurului cablului la rulou",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195901762",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "General"
                                            }
                                        ]
                         },
                         {
                             "id":  "telecomenzi",
                             "name":  "TELECOMENZI",
                             "videos":  [
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--1",
                                                "titlu":  "Copiere multiplicare telecomenzi breloc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195902022",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--2",
                                                "titlu":  "Copiere multiplicare telecomenzi new model",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195902658",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--3",
                                                "titlu":  "Copiere multiplicare telecomenzi",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195902821",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--4",
                                                "titlu":  "Copiere telecomanda întrerupător wireless",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195904920",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--5",
                                                "titlu":  "Multiplicare telecomanda normala breloc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195905176",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--6",
                                                "titlu":  "Schimbarea frecvență telecomanda",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195905557",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--7",
                                                "titlu":  "Setare întrerupător wireless",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195905943",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--8",
                                                "titlu":  "Setare telecomanda 4 canale la centrala ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195906338",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--9",
                                                "titlu":  "Setare telecomanda breloc, motor cu receptor incorporat",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195908838",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--10",
                                                "titlu":  "Setare telecomenzi new model 115 canale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195910509",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--11",
                                                "titlu":  "Setare telecomenzii pe centrala la ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195910946",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-aplicate--telecomenzi--12",
                                                "titlu":  "Setare telecomenzii pe motor",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195912187",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri aplicate",
                                                "codVideo":  "rea",
                                                "folder":  "TELECOMENZI"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "rulouri-suprapuse",
        "name":  "Rulouri suprapuse",
        "codVideo":  "res",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "rulouri-suprapuse--general--1",
                                                "titlu":  "Montaj tabachera șnur_panglica",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195912679",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--2",
                                                "titlu":  "Capăt de cursa a covorului jos",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195913003",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--3",
                                                "titlu":  "Capăt de cursa a covorului sus",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195913569",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--4",
                                                "titlu":  "Cum se scrie în aplicație un rulou casetă comuna",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195913647",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--5",
                                                "titlu":  "Dimensiuni casete rulou suprapus pentru productie",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195914312",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--6",
                                                "titlu":  "Măsurători rulouri în casetă comuna",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195914468",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--general--7",
                                                "titlu":  "Privire_rulou_pentru_producție",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195914840",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "General"
                                            }
                                        ]
                         },
                         {
                             "id":  "telecomenzi",
                             "name":  "TELECOMENZI",
                             "videos":  [
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--1",
                                                "titlu":  "Copiere multiplicare telecomenzi breloc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195915387",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--2",
                                                "titlu":  "Copiere multiplicare telecomenzi new model",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195915511",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--3",
                                                "titlu":  "Copiere multiplicare telecomenzi",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195916260",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--4",
                                                "titlu":  "Copiere telecomanda întrerupător wireless",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195916474",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--5",
                                                "titlu":  "Multiplicare telecomanda normala breloc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917063",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--6",
                                                "titlu":  "Schimbarea frecvență telecomanda",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917271",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--7",
                                                "titlu":  "Setare întrerupător wireless",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917478",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--8",
                                                "titlu":  "Setare telecomanda 4 canale la centrala ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917739",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--9",
                                                "titlu":  "Setare telecomanda breloc, motor cu receptor incorporat",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917951",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--10",
                                                "titlu":  "Setare telecomenzi new model 115 canale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195918344",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--11",
                                                "titlu":  "Setare telecomenzii pe centrala la ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195918629",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "rulouri-suprapuse--telecomenzi--12",
                                                "titlu":  "Setare telecomenzii pe motor",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195918938",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri suprapuse",
                                                "codVideo":  "res",
                                                "folder":  "TELECOMENZI"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "rulouri-exterioare-transparente",
        "name":  "Rulouri exterioare transparente",
        "codVideo":  "ret",
        "sections":  [
                         {
                             "id":  "general",
                             "name":  "General",
                             "videos":  [
                                            {
                                                "id":  "rulouri-exterioare-transparente--general--1",
                                                "titlu":  "Măsurători folii transparente",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195919195",
                                                "thumbnail":  "",
                                                "produs":  "Rulouri exterioare transparente",
                                                "codVideo":  "ret",
                                                "folder":  "General"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "usi-de-garaj",
        "name":  "Usi de garaj",
        "codVideo":  "ug",
        "sections":  [
                         {
                             "id":  "telecomenzi",
                             "name":  "TELECOMENZI",
                             "videos":  [
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--1",
                                                "titlu":  "Copiere multiplicare telecomenzi breloc",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195915387",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--2",
                                                "titlu":  "Copiere multiplicare telecomenzi new model",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195915511",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--3",
                                                "titlu":  "Copiere multiplicare telecomenzi",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195916260",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--4",
                                                "titlu":  "Setare telecomanda 4 canale la centrala ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917739",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--5",
                                                "titlu":  "Setare telecomanda breloc, motor cu receptor incorporat",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195917951",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--6",
                                                "titlu":  "Setare telecomenzi new model 115 canale",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195918344",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            },
                                            {
                                                "id":  "usi-de-garaj--telecomenzi--7",
                                                "titlu":  "Setare telecomenzii pe centrala la ușă garaj",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195918629",
                                                "thumbnail":  "",
                                                "produs":  "Usi de garaj",
                                                "codVideo":  "ug",
                                                "folder":  "TELECOMENZI"
                                            }
                                        ]
                         }
                     ]
    },
    {
        "id":  "plase-anti-insecte",
        "name":  "Plase anti insecte",
        "codVideo":  "pi",
        "sections":  [
                         {
                             "id":  "plase-rulou-tip-fereastra",
                             "name":  "Plase rulou tip fereastra",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-fereastra--1",
                                                "titlu":  "ACTIONARE PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195920025",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip fereastra"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-fereastra--2",
                                                "titlu":  "MASURATOARE PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195920069",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip fereastra"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-fereastra--3",
                                                "titlu":  "MONTAJ PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195920884",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip fereastra"
                                            }
                                        ]
                         },
                         {
                             "id":  "plase-rulou-tip-usa",
                             "name":  "Plase rulou tip usa",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-usa--1",
                                                "titlu":  "ACTIONARE PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195922145",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip usa"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-usa--2",
                                                "titlu":  "MASURATOARE PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195922317",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip usa"
                                            }
                                        ]
                         },
                         {
                             "id":  "plase-rulou-tip-usa-doua-canate",
                             "name":  "Plase rulou tip usa doua canate",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-usa-doua-canate--1",
                                                "titlu":  "ACTIONARE PLASA RULOU",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195922741",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip usa doua canate"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-rulou-tip-usa-doua-canate--2",
                                                "titlu":  "MONTAJUL PLASEI TIP RULOU PENTRU USA 2 CANATE",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195922784",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase rulou tip usa doua canate"
                                            }
                                        ]
                         },
                         {
                             "id":  "plase-plisse-tip-fereastra",
                             "name":  "Plase plisse tip fereastra",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-fereastra--1",
                                                "titlu":  "ACTIONAREA PLASELOR PLISSE",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195923295",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip fereastra"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-fereastra--2",
                                                "titlu":  "MASURATOARE PLASA PLISSE TIP USA SI TIP FEREASTRA",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195923316",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip fereastra"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-fereastra--3",
                                                "titlu":  "MONTAJ PLASA PLISSE TIP FEREASTRA",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195923815",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip fereastra"
                                            }
                                        ]
                         },
                         {
                             "id":  "plase-plisse-tip-usa",
                             "name":  "Plase plisse tip usa",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-usa--1",
                                                "titlu":  "ACTIONAREA PLASELOR PLISSE",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195921317",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip usa"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-usa--2",
                                                "titlu":  "MASURATOARE PLASA PLISSE TIP USA SI TIP FEREASTRA",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195921737",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip usa"
                                            }
                                        ]
                         },
                         {
                             "id":  "plase-plisse-tip-usa-doua-canate",
                             "name":  "Plase plisse tip usa doua canate",
                             "videos":  [
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-usa-doua-canate--1",
                                                "titlu":  "ACTIONAREA PLASELOR PLISSE",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195924039",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip usa doua canate"
                                            },
                                            {
                                                "id":  "plase-anti-insecte--plase-plisse-tip-usa-doua-canate--2",
                                                "titlu":  "Asamblare plase plisse două canate",
                                                "descriere":  "",
                                                "url":  "https://player.vimeo.com/video/1195924217",
                                                "thumbnail":  "",
                                                "produs":  "Plase anti insecte",
                                                "codVideo":  "pi",
                                                "folder":  "Plase plisse tip usa doua canate"
                                            }
                                        ]
                         }
                     ]
    }
];

export default videoList;
